import axios from 'axios'

const axiosConfig = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '',
  headers: {
    accept: 'application/json'
  }
})

axiosConfig.interceptors.request.use((config) => config)

axiosConfig.interceptors.response.use(
  (response) => response,
  (err) => {
    if (err.response.status === 401) {
      localStorage.removeItem('codingIt_admin_token')
      location.reload()
    }
    return Promise.resolve(err.response)
  }
)

export { axiosConfig }
